
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"2 2 20 20","fill":"none","stroke-width":"1.5","stroke-linecap":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"plus-filled-circle_mask"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"stroke":"#000"}},[_c('path',{attrs:{"d":"M12 8v8M16 12H8"}})])]),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9","fill":"currentColor","stroke":"currentColor","mask":"url(#plus-filled-circle_mask)"}})])
          )
        }
      }
    